module.exports = __webpack_public_path__ + "img/exhibition-6.323e416f.png";